/**
 * The yearly guarantee test: "both" (3-day money-back + beat your score) against "grade_only" (beat your score only).
 *
 * ENDED 2026-10-21: grade_only kept (both arms tied: conversion 3.4% vs 3.8%, p=0.57; revenue per viewer $1.53 vs
 * $1.79, p=0.60), and the 3-day guarantee cost about 4% of new yearly revenue in refunds. Beat your score is the only
 * guarantee for new yearly purchases. The id stays so it is never reused.
 */
export const GUARANTEE_EXPERIMENT_ID = "upsell_guarantees_2026_10";

/**
 * What every yearly Stripe checkout sends as `guarantee_experiment_variant`: the backend tags the subscription with it,
 * and support's refund rules read the tag (a subscription tagged earlier with "both", or bought before the test, keeps
 * the 3-day money-back guarantee on its renewals; terms at jungleai.com/guarantee).
 */
export const YEARLY_CHECKOUT_GUARANTEE_VARIANT = "grade_only";
